/**
 * Parse date string in local timezone
 * Handles both ISO timestamp format (legacy) and simple date format (new)
 * @param {string} dateStr - Date string to parse
 * @returns {Date|null} - Parsed date or null if invalid
 */
export const parseLocalDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return null;
  
  // Handle ISO timestamp format (legacy data: "2025-11-09T06:00:00.000Z")
  if (dateStr.includes('T')) {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return null;
    // Return date in local timezone (just the date part, no time)
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  
  // Handle simple date format (new data: "2025-11-09")
  const parts = dateStr.split('-');
  if (parts.length !== 3) return null;
  const [year, month, day] = parts.map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
  const date = new Date(year, month - 1, day);
  // Check if date is valid
  if (isNaN(date.getTime())) return null;
  return date;
};
